import { User } from "firebase/auth"
import { IIllustrokeUser, IUserRequest } from "../../types"
import { storeObjectInLocalStorage } from "../../utils/localStorage"

export interface IUserState {
  userFirebase: User | null,
  userInfo: IIllustrokeUser | null,
  token: string | null,
  colorPickerLastChoices: string[],
  colorpalette: string,
  colorlimit?: number,
  userRequests: IUserRequest[],
  userRequestsInitialized: boolean, // we use to avoid too much userRequests calls
  copyStyleReferenceUrls?: string[] // List of URLs of styles uploaded by the user
}

const initialState: IUserState = {
  userInfo: null,
  userFirebase: null,
  token: null,

  // The color palette used during generation (advanced options)
  colorpalette: '#ffffff,#0500ff,#e6db63,#e878ce,#272727',

  // The preset colors available when using the Color Picker
  // This is also stored in local storage in key: colors-picker-last-choices-v0
  colorPickerLastChoices: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'],

  // max number of colors allowed
  colorlimit: undefined,

  copyStyleReferenceUrls: [],
  userRequests: [],
  userRequestsInitialized: false
}

function user(state = initialState, action: any) {
  switch (action.type) {
    case 'SET_USER_FIREBASE':
      return {
        ...state,
        userFirebase: action.payload
      }
    case 'SET_USER_INFO':
      return {
        ...state,
        userInfo: action.payload
      }
    case 'SET_USER_TOKEN':
      return {
        ...state,
        token: action.payload
      }
    case 'SET_USER_REQUESTS_INITIALIZED':
      return {
        ...state,
        userRequestsInitialized: action.payload
      }
    case 'ADD_USER_REQUEST':
      if (!state.userRequests.find(r => r.id === action.payload.id)) {
        return {
          ...state,
          userRequests: [...state.userRequests, action.payload]
        }
      }
      return state
    case 'EDIT_USER_REQUEST':
      const reqIndex = state.userRequests.findIndex((req => req.id === action.payload.id));
      if (reqIndex > -1) {
        const copyUserRequests = state.userRequests.slice();
        copyUserRequests[reqIndex] = action.payload;
        return {
          ...state,
          userRequests: copyUserRequests
        }
      }
      return state
    case 'DELETE_USER_REQUEST':
      const reqIndexToDelete = state.userRequests.findIndex((req => req.id === action.payload.id));
      if (reqIndexToDelete > -1) {
        const copyUserRequests = state.userRequests.slice();
        copyUserRequests.splice(reqIndexToDelete, 1)
        return {
          ...state,
          userRequests: copyUserRequests
        }
      }
      return state
    case 'DELETE_ALL_USER_REQUEST':
      return {
        ...state,
        userRequests: []
      }
    case 'SET_COLOR_PICKER_LAST_CHOICES':
      return {
        ...state,
        colorPickerLastChoices: action.payload
      }

    case 'ADD_COLOR_PICKER_LAST_CHOICES':
      //If color exist in palette do nothing
      if (state.colorPickerLastChoices.includes(action.payload.toUpperCase())) {
        return state
      }

      const copyColorPickerLastChoices = state.colorPickerLastChoices.slice();
      copyColorPickerLastChoices.pop();

      storeObjectInLocalStorage("colors-picker-last-choices-v0", [action.payload.toUpperCase(), ...copyColorPickerLastChoices]);

      return {
        ...state,
        colorPickerLastChoices: [action.payload.toUpperCase(), ...copyColorPickerLastChoices]
      }

    case 'CHANGE_USER_TOKENS_BY_X':
      const copyUserInfo = JSON.parse(JSON.stringify(state.userInfo)) as IIllustrokeUser;
      if (state.userInfo && action.payload) {
        copyUserInfo.tokens = state.userInfo?.tokens + action.payload;
      }
      return {
        ...state,
        userInfo: copyUserInfo
      }

    case 'SET_COLOR_PALETTE':
      storeObjectInLocalStorage("colorpalette-v0", action.payload); //This make this field persistent
      return {
        ...state,
        colorpalette: action.payload
      }

    case 'SET_COLOR_LIMIT':
      storeObjectInLocalStorage("colorlimit-v0", action.payload);
      return {
        ...state,
        colorlimit: action.payload
      }
    
    case 'ADD_COPY_STYLE_REFERENCE_URL':
      if (state.copyStyleReferenceUrls && !state.copyStyleReferenceUrls.includes(action.payload)) {
        const updatedUrls = [...state.copyStyleReferenceUrls, action.payload];
        storeObjectInLocalStorage("copy-style-reference-urls-v0", updatedUrls);
        return {
          ...state,
          copyStyleReferenceUrls: updatedUrls
        }
      }
      return state;

    case 'SET_COPY_STYLE_REFERENCE_URLS':
      return {
        ...state,
        copyStyleReferenceUrls: action.payload
      }

    default:
      return state
  }
}

export default user